<template>
  <AppShell />
  <GlobalPreloader />
</template>

<script setup>
import AppShell from '@/layouts/AppShell.vue';
import GlobalPreloader from '@/components/common/GlobalPreloader.vue';
</script>
